
import { toMapMarkers } from 'utils/trainer-card-projection'
import Head from 'next/head'
import { getRequestJSON } from '../../../api/index/location-api';
import Script from 'next/script'
import { getArticleDateTime } from '../../../utils/article-date-time';
import { getDistanceMetrics } from '../../../utils/distance-matrix';
import { downloadServiceProviders } from '../../../api/service-provider/sp-list';
import { countryList, googleApiKey, s3Static } from '../../../utils/constants';
import { blogsMaster } from 'utils/sg-blogs-data';
import { getWpNewPostsByCategory, getWpPostsByCategory } from 'lib/service';
import { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { PersonalTrainerHead } from '@/index/service-category/personal-trainer/PersonalTrainerHead';
import Image from 'next/image';
import { DollarSign, Dumbbell, Users } from 'lucide-react';
import { TrainerByFitnessType } from '@/index/service-category/personal-trainer/TrainerByFitnessType';
import { TrainerByType } from '@/index/service-category/personal-trainer/TrainerByType';
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import Link from 'next/link';
import ExploreOptions from '@/index/service-category/personal-trainer/ExploreOptions';
import ResearchCompare from '@/index/service-category/personal-trainer/ResearchCompare';
import { ptSingaporeFaqs } from 'utils/faq';
import { BlogsList } from '@/blogs/BlogList';
import { TrainersNeighborhood } from '@/index/service-category/personal-trainer/TrainersNeighborhood';
import { LoadingCover } from '@/commons/LoadingCover';
import { RequestProvider } from 'context/RequestContext';
import { openModal } from 'service/modal-service';
import { DarkFaq } from '@/index/service-category/personal-trainer/DarkFaq';
import { localBusinessNode, buildServiceNode } from 'utils/local-business-schema'

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps() {

    const { modifiedDate, month, year } = getArticleDateTime();

    const countryName = "Singapore"
    
    const allRequestCategorySettings = await getRequestJSON(countryName)

    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Fitness Trainer")

    const distanceUnit = getDistanceMetrics(countryName)
    
    const lat = 1.3521
    const lng = 103.8198

    const spListMap =  await downloadServiceProviders("Fitness Trainer", 0, 500, "Singapore", lat, lng, 50, "kms", false, false, true)
    const fitnessBlogs = blogsMaster['health-fitness'].blogArray;
    const wpPosts = await getWpPostsByCategory(6, "health-fitness");
    const wpNewPosts = await getWpNewPostsByCategory(6, "health-fitness");

    let spLocationList = []

    for(let x = 0; x < spListMap.length; x++){
        let listA = [spListMap[x].userFirstName, spListMap[x].userLatitude, spListMap[x].userLongitude, x+1]
        spLocationList.push(listA)
    }

    const getLocalityList = () => {
      for(let x in countryList){
          if(countryList[x].country_name === countryName){
              return countryList[x].localityList
          }
      }
    } 
  
    const localityList = getLocalityList()
    
  return {
      props: {
        requestCategorySettings,
        countryName,
        modifiedDate,
        month,
        year, 
        localityList,
        spListMap: toMapMarkers(spListMap),
        spLocationList,
        fitnessBlogs,
        wpNewPosts,
        wpPosts
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// the path has not been generated.
// export async function getStaticPaths() {

//     // Get the paths we want to pre-render based on posts
//     const paths = countryList.map((country) => ({
//       params: { countryCd: country.country_cd },
//     }))

//     // We'll pre-render only these paths at build time.
//     // { fallback: blocking } will server-render pages
//     // on-demand if the path doesn't exist.
//     return { paths, fallback: 'blocking' }
// }

export default function Home(props) {
    const router = useRouter()
    const requestCategorySettings = props.requestCategorySettings
    const countryName = props.countryName
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const localityList = props.localityList
    const spListMap = props.spListMap
    const spLocationList = props.spLocationList
    const fitnessBlogs = props.fitnessBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts

    const requestType = "Fitness Trainer"
    const [ requestForm, setRequestForm ] = useState(true)
    const [isQuickBook, setIsQuickBook] = useState(false)
    const [isCustomBook, setIsCustomBook] = useState(false)

    const [ isLoading, setIsLoading ] = useState(false)

    useEffect(() => {
        if(router.query.requestForm === "true"){
            setRequestForm(true)
            openModal(setRequestForm)
        }
    }, [router]) 

    const openRequestForm = () => {
        window.scrollTo({ top: 0 });
        openModal(setRequestForm)
    }

    useEffect(() => {
        if(router.query.requestForm === "true"){
            setRequestForm(true)
            openModal(setRequestForm)
        }
    }, [router])

    const relOptions = {
        /* … */
        target: "_blank",
        className: "text-orange-800",
        rel: "noopener nofollow noreferrer"
    };    

    const trainerDensity = [
        { region: 'East', trainerPercent: 30 },
        { region: 'West', trainerPercent: 10 },
        { region: 'Central', trainerPercent: 40 },
        { region: 'North', trainerPercent: 20 }
    ];

    const initMap = useCallback( async() =>  {        
        const map = new google.maps.Map(document.getElementById('map'), {
            zoom: 11,
            center: new google.maps.LatLng(1.3521, 103.8198),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            streetViewControl: false,
            mapTypeControl: false,
            mapId: "b76338e454946df6"
        });
        
        const infoWindow = new google.maps.InfoWindow();

        let i;
        for (i = 0; i < spLocationList.length; i++) {  
            const position = new google.maps.LatLng(spLocationList[i][1], spLocationList[i][2]);

            // Create a mini avatar card as marker content
            const markerContent = document.createElement('div');
            markerContent.style.display = 'flex';
            markerContent.style.flexDirection = 'column';
            markerContent.style.alignItems = 'center';
            markerContent.style.textAlign = 'center';
            markerContent.style.backgroundColor = 'transparent';
            markerContent.style.fontFamily = 'sans-serif';

            const img = document.createElement('img');
            img.src = "/personal-trainer.png";
            img.style.width = '20px';
            img.style.height = '30px';
            img.style.borderRadius = '50%';
            img.style.objectFit = 'cover';
            img.alt = 'Trainer avatar';

            markerContent.appendChild(img);
            markerContent.style.transition = 'transform 0.2s ease';
            markerContent.addEventListener('mouseenter', () => {
            markerContent.style.transform = 'scale(1.05)';
            });
            markerContent.addEventListener('mouseleave', () => {
            markerContent.style.transform = 'scale(1)';
            });

            const marker = new google.maps.marker.AdvancedMarkerElement({
            map,
            position,
            content: markerContent,
            });

            const contentString =
                    '<div id="content">' +
                    '<div id="siteNotice">' +
                    "</div>" +
                    '<h3 id="firstHeading" class="text-center text-base font-bold pb-2">' + spListMap[i].userFirstName + '</h3>' +
                    '<div id="bodyContent" class="w-40">' +                    
                    "<div class='flex'><img class='rounded-lg w-full' src='" + spListMap[i].profilePic + "' layout='fill' height='140px' alt='profile image'/>" +
                    "</div>" + 
                    "<div class='text-center text-xs'>" + spListMap[i].userLocation + "</div>" +
                    "</div>" +
                    "<div class='text-center py-2'><a class='text-orange-600 font-bold' target='_blank' rel='noreferrer' href='/profile/" + spListMap[i].handleName + "'>View Profile</a></div>" +
                    "</div>" +
                    "</div>";    

            marker.addListener('gmp-click', () => {
                infoWindow.setContent(contentString);
                infoWindow.open(map);
                infoWindow.setPosition(position); // 👈 anchor by LatLng, not marker
            });
        }
    }, [spListMap, spLocationList])
    
    useEffect(() => {
        window.initMap = () => {
            initMap(); // assign for Google callback
        };

        if (window.google && window.google.maps) {
            initMap(); // call directly if already loaded
        }
    }, [initMap]);

    const tocItems = [
        { id: "define-your-needs", label: "1. Define Your Needs" },
        { id: "explore-options", label: "2. Explore Different Options" },
        { id: "research-and-compare", label: "3. Research and Compare" },
        { id: "consider-commitment", label: "4. Consider Your Commitment" },
        { id: "negotiate-finalise", label: "5. Negotiate and Finalise" },
    ];    
    
  return (
    <>
      <Head>
        <title>Find the Best Personal Trainer in Singapore: 5-Step Guide</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description"
            content={`Discover how to find the perfect personal trainer in Singapore with our expert 5-step guide. Learn to define your fitness needs, explore options, research qualifications, consider commitment, and negotiate confidently. Start your fitness journey today!`}/>
        <meta name="keywords"
            content="Fitness trainer Singapore, personal trainer Singapore, gym Singapore, weight loss Singapore, bodybuilding Singapore,
                    exercise Singapore, personal trainer, lifestyle Singapore, weight loss, fat loss Singapore"/>
        <meta name="author" content="StringsSG - Personal Training"/>
        <meta name="google-site-verification"
            content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"  content={`https://www.stringssg.com/sg/personal-trainer/find-singapore-trainer-guide`} />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Find the Best Personal Trainer in Singapore: 5-Step Guide`}/>
        <meta property="og:description" content={`Discover how to find the perfect personal trainer in Singapore with our expert 5-step guide. Learn to define your fitness needs, explore options, research qualifications, consider commitment, and negotiate confidently. Start your fitness journey today!`}/>
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-08-09T00:00:00+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/personal-trainer/personal-trainer-singapore.jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:video" content="https://www.youtube.com/watch?v=CC4Pe6-I1PY"/>
        <meta property="video:duration" content="16"/>
        <meta property="og:video:width" content="840"/>
        <meta property="og:video:height" content="473"/>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content={`https://www.stringssg.com/sg/personal-trainer/find-singapore-trainer-guide`}/>
        <meta name="twitter:title" content={`Find the Best Personal Trainer in Singapore: 5-Step Guide`}/> 
        <meta name="twitter:description" content={`Discover how to find the perfect personal trainer in Singapore with our expert 5-step guide. Learn to define your fitness needs, explore options, research qualifications, consider commitment, and negotiate confidently. Start your fitness journey today!`}/> 
        <meta name="twitter:image" content="https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/personal-trainer/personal-trainer-singapore.jpeg" /><link rel="icon" href="/favicon.ico" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@type":"BreadcrumbList","@id":"https://www.stringssg.com/sg/personal-trainer/find-singapore-trainer-guide/#breadcrumblist","itemListElement":[{"@type":"ListItem","@id":"https://www.stringssg.com/#listItem","position":1,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/","name":"Home","url":"https://www.stringssg.com/"},"nextItem":"https://www.stringssg.com/sg/personal-trainer/find-singapore-trainer-guide/#listItem"},{"@type":"ListItem","@id":"https://www.stringssg.com/sg/personal-trainer/find-singapore-trainer-guide/#listItem","position":2,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/personal-trainer/find-singapore-trainer-guide/","name":"Personal Trainer Singapore","description":"StringsSG will connect you to the best gym trainer, and male or female personal trainers in Singapore based on your requirements like budget, location, fitness goal and workout time preference.","url":"https://www.stringssg.com/sg/personal-trainer/find-singapore-trainer-guide/"},"previousItem":"https://www.stringssg.com/#listItem"}]},${JSON.stringify(localBusinessNode)},${JSON.stringify(buildServiceNode({ pageUrl: "https://www.stringssg.com/sg/personal-trainer/find-singapore-trainer-guide", name: "Personal Training Singapore", serviceType: "Personal Training", priceRange: "S$84.00 - S$110.00", image: "https://stringssg-assets.s3.ap-southeast-1.amazonaws.com/static/personal-trainer/personal-trainer-singapore.jpeg" }))},{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG Singapore","url":"https://www.stringssg.com/"},{"@type":"WebSite","@id":"https://www.stringssg.com/#website","url":"https://www.stringssg.com/","name":"StringsSG Singapore","inLanguage":"en-US","publisher":{"@id":"https://www.stringssg.com/#organization"}},{"@type":"WebPage","@id":"https://www.stringssg.com/sg/personal-trainer/find-singapore-trainer-guide/#webpage","url":"https://www.stringssg.com/sg/personal-trainer/find-singapore-trainer-guide/","name":"Find the Best Personal Trainer in Singapore: 5-Step Guide","description":"Discover how to find the perfect personal trainer in Singapore with our expert 5-step guide. Learn to define your fitness needs, explore options, research qualifications, consider commitment, and negotiate confidently. Start your fitness journey today!","inLanguage":"en-US","isPartOf":{"@id":"https://www.stringssg.com/#website"},"breadcrumb":{"@id":"https://www.stringssg.com/sg/personal-trainer/find-singapore-trainer-guide/#breadcrumblist"},"datePublished":"2025-08-11T07:30:46+00:00","dateModified":"${modifiedDate}"}]}`
        }}
        />
        <link rel="canonical" href="https://www.stringssg.com/sg/personal-trainer/find-singapore-trainer-guide" />
      </Head> 
        <RequestProvider>
            <PersonalTrainerHead 
                heroImage={s3Static + "personal-trainer/personal-trainer-singapore.jpeg"}
                title="Personal Trainer Singapore - 5 Step Guide"
                    heading="Personal Trainer Singapore - 5 Step Guide"
                heroCopy="A five-step guide to finding and vetting the right personal trainer in Singapore."
                setIsQuickBook={setIsQuickBook}
                openRequestForm={openRequestForm}
                requestForm={requestForm}
                setRequestForm={setRequestForm}
                isQuickBook={isQuickBook}
                isCustomBook={isCustomBook}
                requestType={requestType}
                requestCategorySettings={requestCategorySettings}
            />
        </RequestProvider>
        <section className='max-w-5xl mx-auto py-6 px-2'>
            <div className='grid md:grid-cols-2 gap-10 items-center py-6'>
                <header className='space-y-5 px-2'>
                    <h2 className='text-2xl md:text-4xl text-center uppercase'>
                        <strong>Personal Trainer Singapore - 5 Step Guide</strong>
                    </h2>
                    <div className='space-y-2 leading-8'>
                        <p>
                            Finding a personal trainer in Singapore means exploring options from agencies, fitness studios, and independent coaches.  
                            Whether your goal is <strong>weight loss</strong>, <strong>strength training</strong>, or <strong>rehabilitation</strong>, 
                            there&apos;s a trainer who can match your needs, budget, and preferred location.
                        </p>
                        <p>
                            This guide will walk you through the steps to choose the perfect trainer for your fitness journey.
                        </p>
                    </div>
                </header>
                <div className='relative w-full h-96 hidden md:block'>
                    <Image
                        src={s3Static + "personal-trainer/personal-trainer-png.png"}
                        fill
                        style={{ objectFit: 'contain', objectPosition: 'center' }}
                        placeholder='blur'
                        blurDataURL={s3Static + "placeholder.png"}
                        alt='Personal Trainer Singapore - Find the Right Fit'
                        sizes="(max-width: 768px) 33vw, 50vw"
                    />
                </div>
            </div>   
        </section>
        <nav aria-label="Table of contents" className="max-w-5xl mx-auto my-8 px-4">
            <h2 className="text-2xl md:text-3xl font-semibold mb-4">Table of Contents</h2>
            <ol className="list-inside space-y-2 text-amber-700 text-lg">
                {tocItems.map(({ id, label }) => (
                <li key={id}>
                    <a
                    href={`#${id}`}
                    className="hover:underline focus-visible:outline-amber-500 focus-visible:outline-2"
                    >
                    {label}
                    </a>
                </li>
                ))}
            </ol>
        </nav>
        <section id="define-your-needs" className="max-w-5xl mx-auto py-12 px-4" aria-labelledby="define-needs">
            <header className="text-center mb-12">
                <h2
                id="define-needs"
                className="text-2xl md:text-3xl font-bold text-gray-900"
                >
                    1. Define Your Needs
                </h2>
                <p className="mt-4 max-w-2xl mx-auto  text-gray-600 ">
                Before you start browsing trainer profiles in Singapore, take time to
                figure out exactly what you&apos;re looking for so you can find the right
                match for your fitness journey.
                </p>
            </header>            
            <div className='pt-5'>
                <article>
                    <div className="flex justify-center items-center gap-4 mb-4">
                        <Dumbbell className="w-8 h-8 text-amber-500" />
                        <h3 className="text-xl md:text-2xl font-semibold text-gray-900 uppercase">
                            Fitness Goals
                        </h3>
                    </div>
                    <p className="leading-relaxed text-center text-gray-700">
                        Do you want to lose weight, build muscle, improve endurance, or recover from an injury? Your goal will determine the type of personal trainer you need.
                    </p>
                    <TrainerByFitnessType/>
                </article>
            </div>
            <div className='pt-5'>
                <article>
                    <div className="flex justify-center items-center gap-4 mb-4">
                        <Users className="w-8 h-8 text-amber-500" />
                        <h3 className="text-xl md:text-2xl font-semibold text-gray-900 uppercase">
                            Training Style
                        </h3>
                    </div>
                    <p className="leading-relaxed text-center text-gray-700">
                        Would you prefer one-on-one coaching, small group classes, or the convenience of training at home? Choose what fits your personality and motivation style. You may also consider working with female trainers, as their approach can offer a different perspective and comfort level. There are also trainers who specialize in working with elderly clients, focusing on safe exercises to improve mobility, balance, and overall health.
                    </p>
                    <TrainerByType/>                            
                    <div className='bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow border border-gray-100 space-y-10 my-5 text-center'>
                        <p>
                            Browse over 250 certified fitness professionals offering 1-on-1 coaching and group classes across Singapore.
                        </p> 
                        <div>
                            <Link href="/sg/personal-trainer/trainer-list/Singapore" prefetch={false} 
                            className='text-orange-600 p-3 border border-orange-600 rounded-2xl hover:text-orange-500 hover:shadow-lg'>
                                Personal Trainer List
                            </Link>
                        </div>                            
                    </div>
                </article>
            </div>
            <div className='py-10'>
                <article>
                    <div className="flex justify-center items-center gap-4 mb-4">
                        <DollarSign className="w-8 h-8 text-amber-500" />
                        <h3 className="text-xl md:text-2xl font-semibold text-gray-900 uppercase">
                            Budget
                        </h3>
                    </div>
                    <p className="leading-relaxed text-center text-gray-700">
                        Personal training rates in Singapore typically range from $50 to $180 per session, depending on your goals, the trainer&apos;s experience, and the training location. Some packages also include meal planning and nutrition guidance, which can increase the cost.
                    </p>
                    <div className='py-10'>

                    {/** Goal Tiers */}
                    {[
                    {
                        title: "Basic Goals ($50 - $80)",
                        content:
                        "If your goal is to improve general fitness, lose some weight, or enhance cardiovascular health, you may only need simple guidance on bodyweight and functional training. This entry-level support is more budget-friendly.",
                    },
                    {
                        title: "Average Goals ($80 - $120)",
                        content:
                        "To build muscle, achieve a V-shaped physique, or improve toning, you’ll need a trainer who can tailor strength and cardio routines. These intermediate programs demand more expertise and planning.",
                    },
                    {
                        title: "Advanced Goals ($120 - $180)",
                        content: (
                        <>
                            <p>
                            Advanced personal training is for serious transformation — whether it’s improving your health significantly or preparing for a competition. This level involves careful supervision, often paired with meal planning and health monitoring.
                            </p>
                            <p className="pl-4 pt-2">
                            <span className="font-medium">a. Obese & over 40: </span>Your trainer may need to review your medical reports and adjust your routine to prevent overstraining your heart or joints.
                            </p>
                            <p className="pl-4 pt-2">
                            <span className="font-medium">b. Stage/photo prep: </span>For fitness models or actors, trainers work closely with dietitians to create strict workout and diet plans based on macronutrient manipulation.
                            </p>
                        </>
                        ),
                    },
                    ].map(({ title, content }, i) => (
                        <div key={i} className="md:grid md:grid-cols-4 border border-slate-200 rounded-lg overflow-hidden">
                            <div className="md:col-span-1 p-3 text-orange-600 font-medium bg-slate-50 flex items-center justify-center text-center">
                            {title}
                            </div>
                            <div className="md:col-span-3 p-4 text-sm text-gray-700">{content}</div>
                        </div>
                    ))}
                    </div>
                    <p>
                        A beginner working toward basic goals will likely spend less. As your goals become more ambitious, and your baseline fitness increases, you&apos;ll need more personalized and intensive sessions — which drives up costs.
                    </p>
                    <div className="space-y-4 pt-5">
                        <h4 className="text-center font-semibold text-sm underline uppercase">
                            Rate Chart: Expertise vs. Fitness Goals
                        </h4>
                        <div className="overflow-x-auto">
                        <table className="w-full border-collapse border border-slate-400 text-xs md:text-sm">
                            <thead className="bg-slate-50 text-orange-600">
                            <tr>
                                <th className="border border-slate-300 py-2 text-left px-2">Goal</th>
                                <th className="border border-slate-300 py-2 px-2">Beginner</th>
                                <th className="border border-slate-300 py-2 px-2">Intermediate</th>
                                <th className="border border-slate-300 py-2 px-2">Advanced</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr className="text-gray-600">
                                <td className="border border-slate-300 px-2 py-1 font-semibold text-orange-600">
                                Basic
                                </td>
                                <td className="border border-slate-300 px-2 py-1 text-center">$50 - $80</td>
                                <td className="border border-slate-300 px-2 py-1 text-center">N/A</td>
                                <td className="border border-slate-300 px-2 py-1 text-center">N/A</td>
                            </tr>
                            <tr className="text-gray-600">
                                <td className="border border-slate-300 px-2 py-1 font-semibold text-orange-600">
                                Average
                                </td>
                                <td className="border border-slate-300 px-2 py-1 text-center">$70 - $120</td>
                                <td className="border border-slate-300 px-2 py-1 text-center">$70 - $120</td>
                                <td className="border border-slate-300 px-2 py-1 text-center">N/A</td>
                            </tr>
                            <tr className="text-gray-600">
                                <td className="border border-slate-300 px-2 py-1 font-semibold text-orange-600">
                                Advanced
                                </td>
                                <td className="border border-slate-300 px-2 py-1 text-center">$120 - $180</td>
                                <td className="border border-slate-300 px-2 py-1 text-center">$120 - $180</td>
                                <td className="border border-slate-300 px-2 py-1 text-center">$120 - $180</td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                </article>
            </div>            
            <div className='pt-10'>
                <article>
                    <div className="flex justify-center items-center gap-4 mb-4">
                        <Users className="w-8 h-8 text-amber-500" />
                        <h3 className="text-xl md:text-2xl font-semibold text-gray-900 uppercase">
                            Location
                        </h3>
                    </div>
                    <p className="leading-relaxed text-center text-gray-700">
                        Decide whether you&apos;d like to train at a specific gym, a boutique fitness studio, or in the comfort of your own home.
                    </p>
                    <p className='py-5'>
                        As per our analytics research data, dated 11th July 2025, it is much easier for you to find a wide variety of personal trainers in the Central region of 
                        Singapore area followed by East. The below graph represents the concentration of personal trainers in different regions of Singapore.
                    </p>

                    <div className="h-74 max-w-md mx-auto py-5">
                        <h4 className="text-sm font-semibold text-center text-gray-700 mb-2">
                            Trainer Distribution Across Singapore Regions
                        </h4>
                        <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={trainerDensity}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="region" />
                            <YAxis />
                            <Tooltip formatter={(v) => [`${v}%`, 'Percent']} />
                            <Legend />
                            <Bar dataKey="trainerPercent" fill="#ff9933" name="Trainer Percent" />
                        </BarChart>
                        </ResponsiveContainer>
                    </div>

                    <div className='py-5 px-2 space-y-2 leading-7'>
                        <p className=''>
                            Here are a few ways you can find a personal trainer or gym near you -
                        </p>
                        <div className='space-y-2'>
                            <p>
                                <strong>StringsSG - </strong>StringsSG has a huge database of gyms and trainers in almost every location in Singapore. You can either open a request for a 
                                personal trainer or you can just browse through the list and search for personal trainers near your location.                            
                            </p>
                            <p>
                                <strong>Google - </strong>Jump onto Google to start searching and browsing gyms and trainers near you.
                            </p>
                            <p>
                                <strong>Referral - </strong>Sometimes our friends and relatives may know of a nice gym or personal trainer that they can recommend.
                            </p>
                            <p>
                                <strong>Near By Gym - </strong>Walk-in to a gym and talk to the sales person in charge about your desired fitness goal and they will provide you with the 
                                relevant personal trainer.
                            </p>
                            <p>
                                Find trainers near you with the map based <q>Personal Trainer Locator</q> tool built by StringsSG.
                            </p>
                            <div className='bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow border border-gray-100 space-y-10 mt-10 text-center'>
                                <p>
                                    Easily search and compare trainers by location, price, and training style using our interactive tools.
                                </p> 
                                <div>
                                    <Link href="/sg/personal-trainer/personal-trainer-finder-tool" prefetch={false} 
                                    className='text-orange-600 p-3 border border-orange-600 rounded-2xl hover:text-orange-500 hover:shadow-lg'>
                                        Personal Trainer Finder
                                    </Link>
                                </div>                            
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </section>
        <ExploreOptions/>
        <ResearchCompare/>
        <section
            id="consider-commitment"
            className="max-w-5xl mx-auto py-12 px-4"
            aria-labelledby="consider-commitment-title"
        >
            <header className="text-center mb-10">
                <h2
                id="consider-commitment-title"
                className="text-2xl md:text-3xl font-bold text-gray-900"
                >
                    4. Consider Your Commitment
                </h2>
                <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
                    A great trainer is only part of the equation—your availability and consistency matter too.
                </p>
            </header>

            <article className="space-y-8 text-gray-800 leading-relaxed">
                <section>
                    <h3 className="text-xl font-semibold mb-3">Time Availability</h3>
                    <p>
                        Ensure the trainer&apos;s schedule aligns with your personal availability to maintain a consistent training routine without conflicts.
                    </p>
                </section>

                <section>
                    <h3 className="text-xl font-semibold mb-3">Training Frequency</h3>
                    <p>
                        Discuss with your trainer how often you should train each week to effectively reach your fitness goals, balancing intensity and recovery.
                    </p>
                </section>

                <section>
                <h3 className="text-xl font-semibold mb-3">Long-term Goals</h3>
                    <p>
                        Choose a trainer who can support your long-term fitness journey, helping you sustain progress beyond short-term transformations.
                    </p>
                </section>
            </article>
        </section>  
        <section
            id="negotiate-finalise"
            className="max-w-5xl mx-auto py-12 px-4"
            aria-labelledby="negotiate-finalise-title"
        >
            <header className="text-center mb-10">
                <h2
                id="negotiate-finalise-title"
                className="text-2xl md:text-3xl font-bold text-gray-900"
                >
                    5. Negotiate and Finalise
                </h2>
                <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
                Once you&apos;ve narrowed down your choice, it&apos;s time to make arrangements.
                </p>
            </header>

            <article className="space-y-8 text-gray-800 leading-relaxed">
                <section>
                    <h3 className="text-xl font-semibold mb-3">Pricing</h3>
                    <p>
                        Ask about session rates, package discounts, and payment terms to find an option that fits your budget.
                    </p>
                    <div className='bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow border border-gray-100 space-y-10 mt-10 text-center'>
                        <p>
                            Estimate your personal training costs instantly with our advanced rates calculator.
                        </p> 
                        <div>
                            <Link href="/sg/personal-trainer/personal-trainer-rates-singapore" prefetch={false} 
                            className='text-orange-600 p-3 border border-orange-600 rounded-2xl hover:text-orange-500 hover:shadow-lg'>
                                Rates Calculator
                            </Link>
                        </div>
                    </div>
                </section>

                <section>
                <h3 className="text-xl font-semibold mb-3">Cancellation Policy</h3>
                <p>
                    Understand the trainer&apos;s rescheduling or cancellation rules to avoid unexpected charges and ensure flexibility.
                </p>
                </section>
            </article>
        </section> 
        <div className='pt-10'>
            <h2 className='text-xl text-center p-2 font-bold uppercase'>Map location of {spListMap.length} personal trainers in Singapore</h2>
            <p className='text-center p-2'>Tap the markers on the map to view trainer details</p>
            <div id="map" className='h-120'></div>
        </div>
        <TrainersNeighborhood localityList={localityList}/>
        <section className="relative py-8 md:py-12 overflow-hidden bg-slate-900">
            <div className="absolute top-0 left-0 w-72 h-72 bg-orange-500/8 rounded-full blur-3xl" />
            <div className='relative z-10 max-w-5xl mx-auto px-4'>
                <DarkFaq 
                    title="Personal Training FAQs"
                    questionsAnswers={ptSingaporeFaqs} 
                />
            </div>
        </section>
        <BlogsList blogs={fitnessBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts} theme="dark"/>
        {isLoading &&
          <LoadingCover/>
        }
        <Script
            id="google-maps"
            src={`https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&language=en&libraries=places,marker&callback=initMap&loading=async`}
            strategy="afterInteractive"
        />
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '128634041116395');
                fbq('track', 'PageView');`}
        </Script>
    </>
  )
}